import Repo from './Repo.js'

export default class WarehouseTransactionRepository extends Repo {
  constructor () {
    super('warehouse-transactions')
  }

  all (q, include) {
    return super.all(q, {include: include})
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q, include) {
    return super.paginate(q, include)
  }

  move(id, data) {
    return this.http.post(this.resource + '/' + id + '/move', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  damaged (data) {
    return this.http.post(this.resource + '/damaged', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  fixed (id, data) {
    return this.http.post(this.resource + '/' + id + '/fixed', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
